const LABELS: Record<string, string> = {
  visa: "Visa",
  mastercard: "Mastercard",
  amex: "American Express",
  american_express: "American Express",
  discover: "Discover",
  jcb: "JCB",
  diners: "Diners Club",
  diners_club: "Diners Club",
  unionpay: "UnionPay",
  union_pay: "UnionPay",
  cartes_bancaires: "Cartes Bancaires",
  link: "Stripe Link",
  stripe_link: "Stripe Link",
};

export function cardBrandLabel(brand?: string): string {
  if (!brand) return "Card";
  const key = brand.toLowerCase().trim();
  return LABELS[key] ?? "Card";
}
